import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import createRouter from "./router";
import createStore from "./store";
import createI18n from "./i18n";
import VueMeta from "vue-meta";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Vue.use(VueMeta);

Vue.config.productionTip = false;

// Workaround to fix https://git.io/J3Llx
const ignoreWarnMessage =
  "The .native modifier for v-on is only valid on components but it was used on <svg>.";
// eslint-disable-next-line no-unused-vars
Vue.config.warnHandler = function(msg, vm, trace) {
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};

Vue.mixin({
  methods: {
    showSnakeBar(type, text) {
      this.$store.dispatch("snackbar/setSnackbar", {
        flag: true,
        text,
        color: type
      });
    },
    handle440(status_code) {
      if (status_code === 440) {
        console.log("Session Expired");
        this.showSnakeBar("error", "Session Expired");
      }
    },
    handle403(status_code) {
      if (status_code === 403) {
        console.log("Invalid token");
        this.showSnakeBar("error", "Invalid token");
      }
    },
    handle500(status_code) {
      console.log(status_code);
      if (status_code === 500) {
        console.log("Internal server error");
        this.showSnakeBar("error", "Internal server error");
      }
    },
    /* common  function  for GET API call */
    request_GET(
      url,
      params,
      headers,
      fnSuccessResponse = null,
      fnFailureResponse = null,
      finallyHandler = null
    ) {
      this.$axios
        .get(url, {
          params: params,
          headers: headers
        })
        .then(response => {
          if (fnSuccessResponse != null) {
            fnSuccessResponse(response);
          }
        })
        .catch(error => {
          console.log(error);
          if (!error.response) {
            this.handle440(error.response.data.status_code);
            this.handle403(error.response.data.status_code);
          } else {
            if (fnFailureResponse != null) {
              fnFailureResponse();
            } else {
              this.handle500(500);
            }
          }
        })
        .finally(() => {
          if (finallyHandler !== null) {
            finallyHandler();
          }
        });
    },
    /*convert date formte to dd-mm-yyyy*/
    display_date_formate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      let new_date = `${day}-${month}-${year}`;
      return new_date;
    },
    /* not in use*/
    fetchCardDetails() {
      console.log();
      const self = this;
      let params = {};
      let headers = {};

      /* success response handler  for API Call*/
      const successHandler = response => {
        console.log(response.data);
        self.$store.state.template_preview_dialog.html = response.data;
      };
      // GET API CALL FOR THE TEMPLATE PREVIEW
      this.request_GET(
        this.$store.state.template_preview_dialog.html_url,
        params,
        headers,
        successHandler
      );
    },

    /** Log a Firebase event.
     *
     * To log the event as an ecommerce event, pass the relevant eventName and
     * ecommerceParams from this list:
     * {@link https://firebase.google.com/docs/analytics/measure-ecommerce}
     *
     * @param {string} eventName - name of event.
     * @param {object} ecommerceParams - parameters to be passed with the event.
     */
    logFirebaseEvent(eventName, ecommerceParams = null) {
      if (!process.client || process.env.NODE_ENV !== "production") return;

      if (ecommerceParams) {
        this.$fire
          .analytics()
          .logEvent(
            this.$fireModule.analytics.EventName[eventName],
            ecommerceParams
          );
      } else {
        this.$fire.analytics().logEvent(eventName);
      }
    },

    getRazorpayOptions() {
      const email = this.$store.getters["auth/getUserEmail"];
      const contact = this.$store.getters["auth/getUserMobile"];

      return {
        currency: "INR",
        name: "WedNicely",
        theme: {
          color: this.$vuetify.theme.themes.light.primary
        },
        prefill: { email, contact }
      };
    },

    slugify(val) {
      return val.replace(/ /g, "-").toLowerCase();
    }
  }
});

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    Vue,
    dsn:
      "https://1913bcad5a2b46c6be2d5abab07d8ec7@o362681.ingest.sentry.io/5383040",
    integrations: [new Integrations.BrowserTracing()],

    // TODO: Adjust this value to handle increased traffic in production
    tracesSampleRate: 1.0
  });
}

export default () => {
  const i18n = createI18n();
  const store = createStore();
  const router = createRouter();
  return new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: h => h(App)
  });
};
